import React from "react";
import { graphql } from "gatsby";
import { Embed } from "./Embed";
import {
  KontentComponentLayout,
  KontentComponentSettings,
  StringValue,
} from "../../../types";
import { getComponentSettings } from "../../../lib/componentSettings";

export interface EmbedProps
  extends KontentComponentSettings,
    KontentComponentLayout {
  embed_code: StringValue;
}

const EmbedContainer: React.FC<EmbedProps> = ({ embed_code, ...props }) => {
  const componentSettings = getComponentSettings({ ...props });
  return <Embed code={embed_code?.value} {...componentSettings}></Embed>;
};

export default EmbedContainer;

export const fragmentEmbedContainer = graphql`
  fragment Embed on kontent_item_embed {
    elements {
      embed_code {
        value
      }
      component_settings__hide_on_mobile {
        value {
          codename
        }
      }
      component_settings__anchor_name {
        value
      }
      component_layout__component_width {
        value {
          codename
        }
      }
    }
  }
`;
